import config from '../../config/config';

import getRequest from './base/get';

export default {
  /**
   * Fetch signed image URL for a device by serial number
   * @param {string} deviceSN - The device serial number
   * @returns {Promise<any>} API response containing the signed image URL
   */
  getDeviceImage: (deviceSN: string): Promise<any> => {
    return getRequest(
      `${config.commonApiUrl}api/common/v1/charging-point/device-image/${deviceSN}`,
    );
  },
};
